var SongList = require('../SongList'),
	Song = require('../Song'),
	extend = require('util')._extend;

module.exports = StaticSongList;

//Song list consisting of specific song IDs
function StaticSongList(listName, songIds) {
	SongList.call(this, listName);
	this._songs = {};
	if (songIds) this.setSongIds(songIds);
}

StaticSongList.prototype = Object.create(SongList.prototype);

extend(StaticSongList.prototype, {
	constructor: StaticSongList

  , setSongIds: function(songIds) {
		var songs = {};
		songIds.forEach(function(songId) {
			songs[songId] = null; //this could be set to an actual Song object in some cases instead of null
		});
		this._songs = songs;
	}

  , getSongIds: function() {
        return Object.keys(this._songs);
	}

	//Add new songs to the list (ignores song IDs already in the list)
  , addSongIds: function(songIds) {
        var songs = this._songs;
        songIds.forEach(function(songId) {
            songs[songId] = null;
        });
	}

	//Delete songs from the list
  , removeSongIds: function(songIds) {
        var songs = this._songs;
        songIds.forEach(function(songId) {
            delete songs[songId];
        });
	}

	//Construct a query that will return all the songs in this list
  , getSongsQueryParams: function(orderBy) {
        var songIds = this.getSongIds();
        if (!songIds.length)
            return false;

        var query = {id: {$in: songIds}};
        query.$orderby = orderBy || {sortTitle:1};
        return query;
	}

  , addSong: function(songOrId) {
        if (songOrId instanceof Song) {
            this._songs[songOrId.id] = songOrId;
        }
		else this._songs[songOrId] = null;
	}

  , removeSong: function(songId) {
        if (typeof songId != 'string') {
            console.error("SongList.removeSong(): invalid song ID '"+songId+"'");
        }
        else delete this._songs[songId];
	}

  , toJson: function() {
        return {
            id: this.id
          , name: this.name
          , userId: this.userId
		  , institutionalSubscriptionId: this.institutionalSubscriptionId
          , songIds: this.getSongIds()
		  , shared: this.shared
		  , creatorEmail: this.creatorEmail
		  , editCode: this.editCode
		  , timeCreated: this.timeCreated
          , _prototype: 'StaticSongList'
        };
	}
});